import http from '../http'

// 订单列表数据
export const getOrderList = (param) => http.get(`/api/orders`, param)

// 订单行程小票详情
export const orderTripReceiptsDetail = (param) =>
  http.get(`/api/orders/trips/receipts`, param)
